angular
  .module(__filename, ['ui.router'])

  .factory(
    'confirmActionModal',
    ngInject(($uibModal, Promise) => ({
      open: Promise.method(function(actionString) {
        const modalInstance = $uibModal.open({
          template: require('./template'),
          controller: require('./controller').default,
          controllerAs: 'ctrl',
          size: 'sm',
          resolve: {
            actionString() {
              return actionString || 'Are you sure you want to take this action?';
            },
          },
        });
        return modalInstance.result;
      }),
    })),
  );

export default __filename;
